/**
 * "오늘의 문제" 카드 안에서 챕터명·총 문제 수·진행률 막대를 보여주는 하위 카드.
 * TodayProblem 이 객관식·서술형 각 트랙이 진행 가능한 상태일 때만 이 컴포넌트를 렌더한다.
 */
import React from "react";
import HorizontalLine from "../icons/HorizontalLine";
import ProgressBar from "./ProgressBar";

export interface ProgressCardProps {
  chapter: string;
  totalQuestions: number;
  progress: number;
  /** ProgressBar 끝점 인디케이터 캐릭터 경로. 미지정 시 기본 codingBuddy. */
  characterSrc?: string;
  /** 진행 막대 체크포인트 구간 수. 논서술형은 미션 수. 미지정 시 ProgressBar 기본값. */
  steps?: number;
}

/** 챕터명, "총 N 문제" 배지, 진행률 막대를 세로로 쌓은 카드. progress가 100이면 색을 회색으로 낮춘다. */
const ProgressCard: React.FC<ProgressCardProps> = ({
  chapter,
  totalQuestions,
  progress,
  characterSrc,
  steps,
}) => {
  return (
    <div className="flex flex-col gap-y-[16px] bg-white rounded-[12px] py-[12px] pl-[15px] pr-[25px]">
      <div className="flex items-center justify-between">
        <div
          className={`font-heading text-20  font-bold ${
            progress == 100 ? "text-body" : "text-primary"
          }`}
        >
          {chapter}
        </div>

        <div
          className={`rounded-[20px] px-[10px] py-[7px] ${
            progress == 100 ? "bg-fill" : "bg-primary-muted"
          }`}
        >
          <span
            className={`text-14 font-medium ${
              progress == 100 ? "text-body" : "text-primary"
            }`}
          >
            총 {totalQuestions} 문제
          </span>
        </div>
      </div>

      <HorizontalLine />
      <ProgressBar progress={progress} characterSrc={characterSrc} steps={steps} />
    </div>
  );
};

export default ProgressCard;
